import type { FC, MouseEvent } from 'react'

import { Drawer } from '@/components'
import { E_CertificateTypes } from '@/enums'
import logoPyaterochaBuyCertPng from '@/img/logo-pyaterochka-buy-cert.png?inline'
import logoMagnitBuyCertPng from '@/img/logo-magnit-buy-cert.png?inline'
import logoVkusvillBuyCertPng from '@/img/logo-vkusvill-buy-cert.png?inline'
import {
  SC_OrganizationsList,
  SC_Organization,
} from './styled'
import { useOrganizationsDrawerStore } from './store'
import { useAppStore } from '@/store'


interface T_OrganizationsDrawerProps {
  hideOrganizationsDrawer: () => void
  showBuyCertificateDrawer: () => void
}

export const OrganizationsDrawer: FC<T_OrganizationsDrawerProps> = ({
  hideOrganizationsDrawer,
  showBuyCertificateDrawer,
}) => {
  const certificateCategoriesList = useAppStore((s) => s.certificateCategoriesList)
  const setSelectedOrganization = useOrganizationsDrawerStore((s) => s.setSelectedOrganization)

  const goToBuyCertificateDrawer = (e: MouseEvent<HTMLElement>) => {
    const foundCategory = (certificateCategoriesList || [])
      .find((c) => c.id === Number(e.currentTarget.dataset.id))

    if (!foundCategory) return

    setSelectedOrganization({
      id: foundCategory.id,
      name: foundCategory.name,
      title: foundCategory.title?.ru,
    })

    hideOrganizationsDrawer()
    showBuyCertificateDrawer()
  }


  return (
    <Drawer
      heading='Магазины'
      onClose={hideOrganizationsDrawer}
      isBackdropClosable
    >
      {/* <Input
        placeholder='Название магазина'
        prefix={<SearchOutlined />}
      /> */}

      <SC_OrganizationsList>
        {(certificateCategoriesList || [])
          .filter((c) => !!c.parent)
          .sort((a, b) => a.title?.ru.localeCompare(b.title?.ru))
          .map((c) => (
            <SC_Organization
              key={c.id}
              data-id={c.id}
              data-name={c.name}
              onClick={goToBuyCertificateDrawer}
            >
              <img src={
                c.name === E_CertificateTypes.Magnit
                  ? logoMagnitBuyCertPng
                  : c.name === E_CertificateTypes.Pyaterochka
                    ? logoPyaterochaBuyCertPng
                    : logoVkusvillBuyCertPng
              } alt='' />

              <div>
                <span>{c.title?.ru || 'Неизвестно'}</span>
                <span>Продукты</span>
              </div>
            </SC_Organization>
          ))
        }
      </SC_OrganizationsList>
    </Drawer>
  )
}
